import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api/tgc`;

const client = axios.create({ baseURL: API, timeout: 15000 });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("tgc_jwt");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("tgc_jwt");
    }
    return Promise.reject(err);
  }
);

export default client;
